var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgSalesloft = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "none",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.58412 5.31615C6.58412 3.83332 7.98417 2.63564 9.77623 2.63564C12.0723 2.63564 13.4724 3.71925 14.2564 9.36541H14.7604L15.4884 1.6661C10.2803 -0.158921 3.89603 1.78017 3.78403 7.31226C3.78403 13.3006 13.1363 13.3006 13.1363 18.7757C13.1363 20.3726 11.7363 21.4562 10.1682 21.4562C6.02411 21.4562 5.07207 17.9202 4.84807 14.2131H4.34404L3 21.1711C3 21.1711 6.0801 22.996 9.38422 22.996C13.3604 22.939 15.9925 19.9734 16.1045 16.8366C16.1045 10.8482 6.58412 9.59358 6.58412 5.31615Z",
    fill: "#06492E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.7992 20.8876C16.7992 19.7469 17.6954 18.7774 18.8713 18.7774C20.1038 18.7774 21 19.7469 21 20.8876C21 22.0282 20.1038 22.9977 18.9279 22.9977C17.6395 23.0548 16.7992 22.0282 16.7992 20.8876Z",
    fill: "#B4D625"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgSalesloft);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/Salesloft.7ad9dd6b148d2c6749852c10083972b3.svg";